export default __webpack_public_path__ + "static/media/air_balloon_illustration.24283e9d.svg";